// components/RoleBasedDashboard.jsx
import React from 'react';
import AdminTripDashBoard from '../admin-section/trips/TripDashboard';
import BuyerTripDashBoard from '../buyer-section/trips/TripDashboard';
import { useAuth } from '../auth/AuthProvider';
import AdminSectionTrip from '../admin-section/trips/v2/TripTabs';
import BuyerSectionTrip from '../buyer-section/trips/v2/TripTabs';

const RolesBasedTrips = () => {
  // Mocked user role; in real application, get it from authentication context or a similar state.
  const { screens } = useAuth();
  const userRole = screens?.roleName; // Example: 'admin', 'buyer', 'seller'

  const renderTrips = (role) => {
    switch (role.toLowerCase()) {
      case 'admin':
        return <AdminSectionTrip />;
      case 'buyer':
        return <BuyerSectionTrip />;
      case 'seller':
        return <AdminSectionTrip />;
      default:
        return <div>Unauthorized</div>;
    }
  };

  return  renderTrips(userRole)
};

export default RolesBasedTrips;
